import React from 'react';

function Stats() {
  return <div>Stats</div>;
}

export default Stats;
